// extracted by mini-css-extract-plugin
export default {"videoContainer":"AfterReview_videoContainer__mETrn"};